<template>
    <u-textarea-solo-rounded v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-textarea-solo-rounded>
</template>

<script>
import UTextareaSoloRounded from "@/components/publish/styles/forms/u-textarea-solo-rounded.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        UTextareaSoloRounded,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
